import { render, staticRenderFns } from "./ArtistInvoice.vue?vue&type=template&id=518fb210"
import script from "./ArtistInvoice.vue?vue&type=script&lang=js"
export * from "./ArtistInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports